import "core-js/modules/es.array.push.js";
import { ElCarousel, ElCarouselItem } from "element-plus";
import TemplateSwipeItem from "./TemplateSwipeItem.vue";
export default {
  components: {
    TemplateSwipeItem,
    ElCarousel,
    ElCarouselItem
  },
  props: {
    isMobile: Boolean,
    swipes: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  computed: {
    showNav() {
      return this.isMobile ? true : this.swipes.length > 3;
    }
  },
  data() {
    return {
      swipeArr: [],
      // 处理数据，三个元素为一组
      itemHeight: "100%",
      swiperOptions: {
        lazy: false,
        loop: false,
        // observer: true, // 启动动态检查器(OB/观众/观看者)
        allowTouchMove: false,
        // dynamicBullets: true, // 动态分页
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      }
    };
  },
  beforeMount() {
    let swipes = this.swipes;
    if (swipes && swipes.length) {
      let arr = [];
      let tempArr = [];
      // 将数据三个单项分为一组重新排列
      let splitNum = this.isMobile ? 1 : 3;
      for (let i = 1, len = swipes.length; i <= len; i++) {
        let num = i % splitNum;
        if (num) {
          tempArr.push(swipes[i - 1]);
        } else {
          tempArr.push(swipes[i - 1]);
          // 索引求余为0时，为临时数组最后一项，将临时数组push进arr中，并将临时数组清空，以供下个循环使用
          arr.push([...tempArr]);
          tempArr = [];
        }
      }
      this.swipeArr = arr;
    }
  },
  methods: {
    handleChange(data) {},
    noticeHeight(height) {
      this.itemHeight = height;
    }
  }
};